import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link as ReactLink, useLocation, useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import styled from "@emotion/styled";
import { SignInSchema } from "./Schema";
import { helpHttp } from "../../../helper/helpHttp";
import { useUser } from "../../../hooks/useUser";
import ModalResponse from "../../ModalResponse";
import { toast } from "react-toastify";

const Fields = () => {
  const { logInUser } = useUser();
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState(undefined);
  const { post } = helpHttp();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all", resolver: yupResolver(SignInSchema) });

  const onSubmit = (data) => {
    post("usuarios/getUsuarioByNumeroDocumento", {
      body: data,
    })
      .then((response) => {
        response.codigo === "200" && logInUser(response.datos);
        setResponse(response);
        setOpen(true);
        if (location.state) {
          navigate(location.state?.from?.pathname);
        }
      })
      .catch(() => toast.error("Ha ocurrido un error"));
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      <TextField
        autoComplete="off"
        error={!!errors.numero_documento?.message}
        helperText={errors.numero_documento?.message}
        label="Número de documento"
        type="text"
        variant="standard"
        {...register("numero_documento")}
      />

      <StyledButton color="secondary" type="submit" variant="contained">
        ingresar
      </StyledButton>
      <ModalResponse
        open={open}
        response={response}
        handleClose={handleClose}
      />
    </StyledForm>
  );
};

const StyledForm = styled.form`
  display: flex;
  gap: 15px;
  margin-top: 20px;
  flex-direction: column;
  p {
    font-size: 1rem;
  }
`;

const StyledFormOptions = styled.div`
  margin: 15px 0;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  max-width: 300px;
  align-self: center;
`;

export default Fields;
